



























import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Size } from "../../../domain/drawing";
import { Section } from "../../../domain/document";
import { ComponentWatchableMixin } from "../../system/mixins";

@Component({
  components: {
  },
})
export default class FormatSectionThumbnailViewer extends Mixins(ComponentWatchableMixin) {
  @Prop()
  section: Section;

  @Prop()
  isFocused: boolean;

  @Prop()
  pageNumber: number;

  @Prop({ default: 100 })
  indicatorFontSize: number;

  @Emit()
  click() {}

  data(): any {
    return {
      size: new Size(0, 0),
    };
  }
  size: Size;

  $refs!: {
    root: HTMLDivElement,
  };

  mounted(): void {
    this.onResized();
    this.watchHtmlElementResized("root", (n: Size, o: Size) => this.onResized());
  }

  private onResized(): void {
    this.size = new Size(this.$refs.root.clientWidth - 2, this.$refs.root.clientHeight - 2);
  }

  get scale(): number {
    return (this.isValid(this.size) && this.isValid(this.pageSize))
      ? Math.min(this.size.width / this.pageSize.width, this.size.height / this.pageSize.height)
      : 1.0;
  }

  isValid(source: Size): boolean {
    return (0 < source.width)
        && (0 < source.height);
  }

  get scaledSizeStyle(): any {
    return {
      width: this.scaledSize.width + "px",
      height: this.scaledSize.height + "px",
    };
  }

  get scaledSize(): Size {
    return new Size(
      this.pageSize.width * this.scale,
      this.pageSize.height * this.scale);
  }

  get pageSize(): Size {
    return this.section
      ? this.section.size
      : new Size(0, 0);
  }

  get thumbnailImageSource(): any {
    return !this.section
      ? ""
      : this.section.thumbnailImageSource.source;
  }

  get thumbnailImageWidth(): number {
    return this.scaledSize.width;
  }

  get thumbnailImageHeight(): number {
    return this.scaledSize.height;
  }

  get indicatorStyleProperties(): any {
    return {
      borderWidth: this.isFocused ? this.$configuration.behavior.document.editor.pageNavigator.focusIndicator.borderWidth + "px" : "0px",
    };
  }

  get indicatorTextStyleProperties(): any {
    return {
      fontSize: this.indicatorFontSize + "px",
    };
  }
}
